var g = {
  host: "prodS",
  server: "prodS",
}

var cl=console.log

var initConfig=()=>{
  let hosts={
    prod0:"prod0",
    prod0Test:"prod0Test",
    prodS:"prodS",
    prodX:"prodX",
    dev:"sg",
    ryan:"sg_ryan",
    faiza:"sg_faiza",
    wayne:"wayne",
    stage:"sg_stage",
    alpha:"sg_alpha",
    "faiza-exp":"faiza-exp",
    "sadaf-exp":"sadaf-exp",
    demo:"demo",
  }
  let server=sessionStorage.getItem("serverOverride")
  if(server){
    g.server=server
    g.host=hosts[server]
  }
}

initConfig()
// cl(g)

module.exports = g
